import React from "react";
import "./conditionTimeLine.css";
import moment from "moment";
import { Timeline } from "antd";

const ConditionTimeline = ({ encounterData: data, conditionKey, active }) => {
  if (!active && data?.length === 0) {
    return (
      <h1>
        No timeline for the{" "}
        {conditionKey?.includes("-")
          ? conditionKey.split("-")[0].toLowerCase()
          : conditionKey?.toLowerCase()}{" "}
        condition
      </h1>
    );
  }

  const items = active
    ? data.map((item) => ({
        children: (
          <>
            <p style={{ textTransform: "capitalize" }}>{item.name}</p>
            <p>
              {moment(item.encounter.period.start).format(
                "ddd, MMM Do YYYY, h:mm A"
              )}
            </p>
          </>
        ),
      }))
    : data.map((item) => ({
        children: moment(item.resource.period.start).format(
          "ddd, MMM Do YYYY, h:mm A"
        ),
      }));

  return (
    <div className="timeline">
      <Timeline items={items} />
    </div>
  );
};

export default ConditionTimeline;
